import confetti from 'canvas-confetti';
import { useEffect } from 'react';

import { CelebrationModalConfig } from '../types';

export const useCelebrationModal = (isOpen: boolean, config: CelebrationModalConfig) => {
  useEffect(() => {
    if (!isOpen) return;

    const { duration, startVelocity, spread, ticks, zIndex, intervalMs } = config.confetti;
    const animationEnd = Date.now() + duration;
    const defaults = { startVelocity, spread, ticks, zIndex };

    const randomInRange = (min: number, max: number) => {
      return Math.random() * (max - min) + min;
    };

    const interval = setInterval(() => {
      const timeLeft = animationEnd - Date.now();

      if (timeLeft <= 0) {
        return clearInterval(interval);
      }

      const particleCount = config.confetti.particleCount * (timeLeft / duration);

      // Fire confetti from left side
      void confetti({
        ...defaults,
        particleCount,
        origin: { x: randomInRange(0.1, 0.3), y: Math.random() - 0.2 },
      });

      // Fire confetti from right side
      void confetti({
        ...defaults,
        particleCount,
        origin: { x: randomInRange(0.7, 0.9), y: Math.random() - 0.2 },
      });
    }, intervalMs);

    return () => clearInterval(interval);
  }, [isOpen, config]);

  return {};
};
